import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { ApiError } from '@/shared/api/ApiError';

/**
 * Konfiguracja React Query — jedno miejsce na polityke ponawiania i cache'owania.
 */
function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Bledow autoryzacji i „nie znaleziono” nie ma sensu ponawiac —
          // odswiezeniem tokena zajmuje sie juz klient HTTP.
          if (error instanceof ApiError) {
            if (error.status === 401 || error.status === 403 || error.status === 404) {
              return false;
            }
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export function QueryProvider({ children }: { children: ReactNode }) {
  // Klient tworzymy w stanie, zeby przetrwal ponowne renderowanie,
  // ale nie byl wspoldzielony miedzy testami.
  const [queryClient] = useState(createQueryClient);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
